<template>
  <div class="account-center-container">
    <img
      :src="Images.LOGO_DEFAULT_WHITE"
      @click="onGoIdx"
      style="width: 98px; height: 45px; cursor: pointer"
     alt=""/>
    <img v-if="props.showAccountCenter" :src="Images.SPLIT_LINE"  alt=""/>
    <img
      v-if="props.showAccountCenter"
      :src="Images.LOGO_ACCOUNT_CENTER"
      class="account-center"
      style="width: 98px; height: 45px"
     alt=""/>
    <div style="width: 80px" />
    <template v-if="props.showNav">
      <div class="menu-box">
        <div
          :class="{ selected: hasAccountInfoTab.includes( props.showPage! ) }"
          class="nav"
          @click="$emit('clickNav', Page.ACCOUNT_INFO)"
        >
          账号信息
        </div>

        <div
					v-if="currentAccountInfo.permission > 0"
          :class="{ selected: props.showPage?.startsWith(Page.STAFF_LIST) }"
          class="nav"
          @click="$emit('clickNav', Page.STAFF_LIST)"
        >
          员工列表
        </div>
        <div
          v-if="(tenantContext.mask & 2)"
          :class="{
            selected: props.showPage?.startsWith(Page.SECURITY_CENTER),
          }"
          class="nav"
        >
          <el-dropdown
            trigger="hover"
            style="
              height: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
            "
          >
            <span
              class="el-dropdown-link"
              style="
                cursor: pointer;
                display: flex;
                justify-content: center;
                flex-direction: row;
              "
            >
              <div
                class="user-message-container"
                style="
                  display: flex;
                  flex-direction: row;
                  justify-content: center;
                  font-size: 16px;
                  font-weight: 500;
                  color: #ffffff;
                "
              >
                安全中心
              </div>
            </span>
            <template #dropdown>
              <el-dropdown-menu class="newDrop">
                <el-dropdown-item
                  v-if="(tenantContext.mask & 2)"
                  @click="$emit('clickNav', Page.SECURITY_CENTER)"
                  >安全监控</el-dropdown-item
                >
                <el-dropdown-item
                  v-if="
                    (tenantContext.mask & 2)
                  "
                  @click="$emit('clickNav', Page.SECURITY_CENTER_LOGINLOG)"
                  >日志查看</el-dropdown-item
                >
                <!--el-dropdown-item
                  v-if="
                    (tenantContext.mask & 2)
                  "
                  @click="
                    $emit('clickNav', Page.SECURITY_CENTER_RISKIPOPERATION)
                  "
                  >白名单设置</el-dropdown-item
                >
                <el-dropdown-item
                  v-if="(tenantContext.mask & 2)"
                  @click="$emit('clickNav', Page.ACCESS_TOKEN)"
                  >访问密钥</el-dropdown-item
                >
                <el-dropdown-item
                  v-if="
                    (tenantContext.mask & 2)
                  "
                  @click="
                    $emit('clickNav', Page.SECURITY_THIRDPART_AUTHORIZATION)
                  "
                  >三方授权</el-dropdown-item
							-->
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </div>
    </template>

    <!-- 用户信息 -->
    <div
      v-if="props.showQuit"
      style="
        position: absolute;
        right: 0;
        display: flex;
        padding-right: 32px;
        align-items: center;
      "
    >
      <el-dropdown trigger="click">
        <span
          class="el-dropdown-link"
          style="
            cursor: pointer;
            display: flex;
            justify-content: center;
            flex-direction: row;
          "
        >
          <div
            class="user-message-container"
            style="display: flex; flex-direction: row; justify-content: center"
          >
            <img
              :src="Images.USER_HEADSHOT"
              style="width: 32px; height: 32px; margin-right: 8px"
              alt=""/>
            <div class="sid" style="margin-top: 9px">
              {{
								(tenantContext.mask & 2) ? tenantContext.tenantId : tenantContext.userName
              }}
            </div>
          </div>
          <el-icon
            class="caret-bottom"
            style="margin-left: 8px; margin-top: 9px"
          >
            <i class="icon-icon_xiala icon iconfont" style="color: #ffffff"></i>
          </el-icon>
        </span>
        <template #dropdown>
          <el-dropdown-menu class="newDrop">
            <el-dropdown-item v-if="!currentAccountInfo.oldAccount && isProductMapPage" @click="toAccountInfo">
							<i class="icon-yonghuming icon iconfont" />账号信息
            </el-dropdown-item>
              <el-dropdown-item v-if="!isProductMapPage" @click="toProductMap">
                  <el-icon><MapLocation color="#000" /></el-icon>产品地图
              </el-dropdown-item>


			<el-dropdown-item @click="showAuthCodeDialog">
				<el-icon><Icons.authorize /></el-icon>授权登录
            </el-dropdown-item>
            <el-dropdown-item @click="onClickQuit">
							<i class="icon-icon_quit icon iconfont" />退出</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useRouter,useRoute } from 'vue-router'
import { Images } from '@/assets/Images'
import { Page } from '@/router/router-enum'

import { currentAccountInfo } from "../State";

import { getTenantContext, Icons, showDialog } from "@/components/easy"

import AuthCodeVue from '/src/views/AuthCode/index.vue';
import {onMounted} from "vue";
import {MapLocation} from "@element-plus/icons-vue";

const hasAccountInfoTab = [
  Page.ACCOUNT_INFO,
  Page.RESET_MOBILE,
  Page.RESET_MOBILE_APEAL,
  Page.RESET_PWD,
]
const props = withDefaults(
  defineProps<{
    //显示导航
    showNav?: boolean
    //当前页面
    showPage?: Page
    showAccountCenter?: boolean
    //显示退出
    showQuit?: boolean
  }>(),
  {
    showNav: false,
    showQuit: true,
    showAccountCenter: true,
  }
)

const emits = defineEmits(['clickNav'])

const router = useRouter()
const route = useRoute()
//当前页面是否是产品地图页面
const isProductMapPage = ref(true)

// const storage = window.localStorage
const tenantContext = getTenantContext();

const onGoIdx = () => {
	if(props.showNav) {
  	router.push(Page.LOGIN)
	} else {
		router.push(Page.ACCOUNT_INFO)
	}
}
async function onClickQuit() {
  router.replace(Page.LOGOUT)
}

async function showAuthCodeDialog() {
	await showDialog(AuthCodeVue, {}, {
		title: "授权码",
		customStyle: { width: "600px", height: "300px" }
	});
}

const toAccountInfo = () => {
    //设置当前不是产品地图页面
    isProductMapPage.value = false
    router.push(Page.ACCOUNT_INFO)
}

const toProductMap = () => {
    //设置当前是产品地图页面
    isProductMapPage.value = true
    router.push(Page.PRODUCT_MAP)
}
onMounted(()=>{
    if(route.path == Page.PRODUCT_MAP){
        isProductMapPage.value = true
    }else{
        isProductMapPage.value = false
    }
})

</script>

<style lang="scss" scoped>
.account-center-container {
  height: 60px;
  display: flex;
  width: 100%;
  padding-left: 40px;
  align-items: center;
  user-select: none;
  @media screen and (orientation: portrait) {
    padding-left: 0;
  }

  .account-center {
    font-size: 22px;
    font-weight: 500;
    color: #ffffff;
    margin-left: 8px;
  }

  .menu-box {
    display: flex;
    align-items: center;
    height: 60px;

    @media screen and (orientation: portrait) {
      position: absolute;
      height: 30px;
      bottom: 5px;
      left: 5px;
      z-index: 1000;
      background-color: #ddd;
    }
  }

  .sid {
    font-size: 14px;
    font-weight: 400;
    color: #ffffff;
  }

  .quit-box {
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .quit {
    font-size: 14px;
    font-weight: 400;
    color: #ffffff;
  }

  .nav {
    height: 100%;
    width: 104px;
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    line-height: 60px;
    color: #ffffff;

    @media screen and (orientation: portrait) {
      line-height: 30px;
    }
  }

  .selected {
    background: #247fff;
  }

  .nav:hover {
    cursor: pointer;
  }
}
.newDrop{
  user-select: none;
}
</style>
